"use client"

import { MOCK_INTERVIEW_LANGUAGES } from "@/lib/mock-interview/languages"

interface LanguagePickerProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export function LanguagePicker({ value, onChange, disabled }: LanguagePickerProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
    >
      {MOCK_INTERVIEW_LANGUAGES.map((l) => (
        <option key={l.code} value={l.code}>
          {l.label}
        </option>
      ))}
    </select>
  )
}
